// extracted by mini-css-extract-plugin
module.exports =  {"fadeInContainer":"fadeInContainer_vpUC873d","fadeIn":"fadeIn_J7lMw4dm","titleLabel":"titleLabel_s5YSfrKv","container":"container_LsDQswK4"};